export default __webpack_public_path__ + "static/media/image1.3d1c12c4.jpg";